import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Input, Card, CardBody, CardHeader } from "reactstrap";
import { Link, Redirect, withRouter } from "react-router-dom";
import {Table, Thead, Tbody, Tr, Th, Td} from 'react-super-responsive-table';
import { AvForm, AvField, AvInput } from "availity-reactstrap-validation";
import { paramPost } from "../../apiHelpers/commonApiHelper";

import { connect } from 'react-redux';


import { getMedia } from '../../store/actions';
import Select from "react-select";
//i18n
import { withNamespaces } from 'react-i18next';
import moment from "moment";
import Dropzone from "react-dropzone";
import {trim} from "leaflet/src/core/Util";
import toastr from 'toastr';

const AddDevice = (props) => {


    useEffect(() => {
        // props.getMedia()
    }, [])

    const[loading, setLoading] = useState(false)

    const handleDevice = (e, values) => {
        e.persist();
        setLoading(true);
        const playerName = (values.player_name || "").trim();
        let url = window.location.pathname;
        let code = decodeURI(url.replace('/add_device/',''));
        paramPost("/api/v1/players/approve", { player_name: playerName, player_code: code })
            .then((result) => {
                setLoading(false);
                if(result.data.success) {
                    toastr.success(result.data.message, "Success");
                    setTimeout(() => {
                        window.location.href = "/screens";
                    }, 2000)
                } else {
                    toastr.error(result.data.message, "ERROR")
                }
            })
            .catch((err) => {
                toastr.error("Something went wrong!", "ERROR")
                setLoading(false);
            })
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row className="setup-class">
                        <Col>
                            <Card className="card-style">
                                <CardHeader>Add Device</CardHeader>
                                <CardBody>
                                    <AvForm
                                        className="outer-repeater row m-auto"
                                        style={{width: "100%"}}
                                        onValidSubmit={(e,v) => { handleDevice(e,v) }}
                                    >
                                        <Col sm={12} className="p-0">
                                            <div className="form-group">
                                                <AvField
                                                    type="input"
                                                    label={"Display name (optional if already set)"}
                                                    name="player_name"
                                                    validate={{ required: { value: false } }}
                                                >
                                                </AvField>
                                            </div>
                                        </Col>
                                        <Col sm={12} className="p-0 text-right">
                                            <button className="btn btn-orange" disabled={loading}>
                                                {!loading ?
                                                    "Add Player" :
                                                    <i className="fas fa-spinner fa-spin" style={{width: "100px"}}></i>
                                                }
                                            </button>
                                        </Col>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    const { media } = state.CampaignReducer;
    return { media };
}

export default withRouter(connect(mapStateToProps, { getMedia })(withNamespaces()(AddDevice)));
